module.exports = __webpack_public_path__ + "img/revoke_latex.5421ccdd.svg";